import { memo } from "react";

export const EmptyPlaceholderField = memo(({ data  }: {data?: string | number}) => {
    return data ? <div className="border rounded-md p-2" style={{wordBreak: "break-word"}}>{data}</div> : <div className="border rounded-md py-5"></div>
});